/* Entity auf einer angeklickten Fläche platzieren (3D-Ansicht). Ohne DOM. */
import type { Vec3 } from './types.ts';

/** Würfel, den der Editor zeichnet, wenn die Klasse keine Box (size()) hat */
export const DEFAULT_BOX: [Vec3, Vec3] = [[-8, -8, -8], [8, 8, 8]];

const len = (v: number[]): number => Math.hypot(v[0], v[1], v[2]);

/** Fläche so zur Kamera drehen, dass die Normale entgegen dem Strahl zeigt (unabhängig von der Dreiecksreihenfolge); nil → null */
export function faceNormal(normal: number[] | null, rayDir: number[]): Vec3 | null {
  if (!normal) return null;
  const l = len(normal);
  if (!(l > 1e-9)) return null;
  const n: Vec3 = [normal[0] / l, normal[1] / l, normal[2] / l];
  const d = n[0] * rayDir[0] + n[1] * rayDir[1] + n[2] * rayDir[2];
  return d > 0 ? [0 - n[0], 0 - n[1], 0 - n[2]] : n;
}

/** Ursprung der Entity, damit ihre Box auf der Fläche aufliegt: Treffpunkt plus Abstand entlang der Normalen,
 *  der die Box (relativ zum Ursprung) gerade aus der Fläche hebt. Ergebnis auf ganze Einheiten gerundet. */
export function originOnSurface(point: number[], normal: number[] | null, box: [number[], number[]] | null): Vec3 {
  const b = box || DEFAULT_BOX;
  let lift = 0;
  if (normal) for (let i = 0; i < 3; i++) lift += normal[i] >= 0 ? -b[0][i] * normal[i] : -b[1][i] * normal[i];
  const o = [0, 1, 2].map((i) => Math.round(point[i] + (normal ? normal[i] * lift : 0)));
  return [o[0], o[1], o[2]];
}
